import {
  gearboxMarketCompressor,
  gearboxMarketConfigurators,
} from '@1delta/data-sdk'
import { zeroAddress } from 'viem'

/**
 * Builds the multicall descriptor for Gearbox V3.1 public data.
 *
 * Single call to `MarketCompressor.getMarkets(filter)` with:
 *   - `configurators`: all curators registered for the chain (cp0x,
 *     Chaos Labs, Re7, …) — discovered from the resolver JSON
 *   - `pools: []` — no narrowing, return every market run by those
 *     configurators
 *   - `underlying: 0x0` — no underlying filter
 *
 * The response carries pool + creditManagers + facades + oracle info
 * in one nested struct per market. Parser fans out to per-CM
 * `GEARBOX_V3_<CM_HEX>` buckets.
 *
 * Returns `[]` when the chain has no configurators or MarketCompressor
 * isn't configured — safe no-op.
 */
export const buildGearboxCall = (chainId: string, _lender?: string) => {
  const compressor = gearboxMarketCompressor()
  const configurators = gearboxMarketConfigurators(chainId)
  if (!compressor || !configurators) return []

  const curatorAddrs = Object.keys(configurators)
  if (curatorAddrs.length === 0) return []

  return [
    {
      address: compressor,
      name: 'getMarkets',
      params: [
        {
          configurators: curatorAddrs,
          pools: [] as string[],
          underlying: zeroAddress,
        },
      ],
    },
  ]
}
